<template>
    <td>
        <a v-for="order in data.fulfillment.orders" :href="order.link"
           style="margin: 0 5px;">{{ order.leads_delivered }} / {{ order.leads_ordered }}
            ({{ order.status }})</a>
        <a v-if="!data.fulfillment.orders.length && !data.singlecarrier.products.deja.enabled" :href="data.fulfillment.link">New order</a>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>